var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":['404', '403', '500'].includes('' + _vm.errorType) ? '' + _vm.errorType : 'error',"title":_vm.errorType,"sub-title":_vm.$t('utils.wrong')},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary","size":"large"},on:{"click":_vm.reload}},[_vm._v(" Reload ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }